//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

$('.msdw-page-scroll').click(function() {
  if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
    if (target.length) {
      var offsetValue = 0;
      if ( window.innerWidth <= 767 ) {
        offsetValue;
        // console.log(offsetValue);
      } else {
        offsetValue = 59;
        // console.log(offsetValue);
      }

      $('html,body').animate({
        scrollTop: target.offset().top - offsetValue
      }, 900);
      return false;
    }
  }
});


// CLICK & COLLECT LINKING
const pageScroll = document.querySelector('.msdw-page-scroll');

if (pageScroll) {
  document.querySelector('.msdw-page-scroll').setAttribute('href', '#section3');
  document.querySelector('.msdw-page-scroll').removeAttribute('target');
  document.querySelector('.msdw-page-scroll').removeAttribute('rel');
}


//
// =COUNTRY SELECT FOR EU
// --------------------------------------------------
const countryClassEls = document.querySelectorAll('.country');
const countryMobileClassEls = document.querySelectorAll('.country-mobile');
const select = document.getElementById('countries');
const selectMobile = document.getElementById('countries_mobile');
function updateSelectedCountry() {
  countryClassEls.forEach(countryClassEl => countryClassEl.classList.add('jws-hidden'));
  document.getElementById(`country-${select.value}`).classList.remove('jws-hidden');
}
function updateSelectedCountryMobile() {
  countryMobileClassEls.forEach(countryMobileClassEl => countryMobileClassEl.classList.add('jws-hidden'));
  document.getElementById(`country-${selectMobile.value}`).classList.remove('jws-hidden');  
}
select.addEventListener('change', updateSelectedCountry)
selectMobile.addEventListener('change', updateSelectedCountryMobile)
if (select) {
  if (window.jwsdwSettings.countryCode === 'BE') {select.selectedIndex = 0; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'BG') {select.selectedIndex = 1; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'HR') {select.selectedIndex = 2; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'CY') {select.selectedIndex = 3; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'CZ') {select.selectedIndex = 4; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'DK') {select.selectedIndex = 5; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'EE') {select.selectedIndex = 6; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'FI') {select.selectedIndex = 7; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'FR') {select.selectedIndex = 8; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'GR') {select.selectedIndex = 9; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'HU') {select.selectedIndex = 10; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'IE') {select.selectedIndex = 11; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'IT') {select.selectedIndex = 12; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'LV') {select.selectedIndex = 13; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'LT') {select.selectedIndex = 14; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'LU') {select.selectedIndex = 15; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'NL') {select.selectedIndex = 16; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'PT') {select.selectedIndex = 17; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'RO') {select.selectedIndex = 18; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'SK') {select.selectedIndex = 19; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'SI') {select.selectedIndex = 20; updateSelectedCountry()}
  if (window.jwsdwSettings.countryCode === 'SE') {select.selectedIndex = 21; updateSelectedCountry()}
}
if (selectMobile) {
  if (window.jwsdwSettings.countryCode === 'BE') {selectMobile.selectedIndex = 0; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'BG') {selectMobile.selectedIndex = 1; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'HR') {selectMobile.selectedIndex = 2; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'CY') {selectMobile.selectedIndex = 3; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'CZ') {selectMobile.selectedIndex = 4; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'DK') {selectMobile.selectedIndex = 5; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'EE') {selectMobile.selectedIndex = 6; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'FI') {selectMobile.selectedIndex = 7; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'FR') {selectMobile.selectedIndex = 8; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'GR') {selectMobile.selectedIndex = 9; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'HU') {selectMobile.selectedIndex = 10; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'IE') {selectMobile.selectedIndex = 11; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'IT') {selectMobile.selectedIndex = 12; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'LV') {selectMobile.selectedIndex = 13; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'LT') {selectMobile.selectedIndex = 14; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'LU') {selectMobile.selectedIndex = 15; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'NL') {selectMobile.selectedIndex = 16; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'PT') {selectMobile.selectedIndex = 17; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'RO') {selectMobile.selectedIndex = 18; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'SK') {selectMobile.selectedIndex = 19; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'SI') {selectMobile.selectedIndex = 20; updateSelectedCountryMobile()}
  if (window.jwsdwSettings.countryCode === 'SE') {selectMobile.selectedIndex = 21; updateSelectedCountryMobile()}
}

// //
// // =COUNTRY SELECT FOR EU
// // --------------------------------------------------

// const countryClassEls = document.querySelectorAll('.country');
// const countryMobileClassEls = document.querySelectorAll('.country-mobile');
// const select = document.getElementById('countries');

// $(document).ready(function(){
//   updateSelectedCountry();
// });

// function updateSelectedCountry() {
//   countryClassEls.forEach(countryClassEl => countryClassEl.classList.add('jws-hidden'));
//   countryMobileClassEls.forEach(countryMobileClassEl => countryMobileClassEl.classList.add('jws-hidden'));
//   document.getElementById(`country-${select.value}`).classList.remove('jws-hidden');
// }

// select.addEventListener('change', updateSelectedCountry)

// if (select) {
//   if (window.jwsdwSettings.countryCode === 'BE') {select.selectedIndex = 0; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'BG') {select.selectedIndex = 1; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'HR') {select.selectedIndex = 2; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'CY') {select.selectedIndex = 3; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'CZ') {select.selectedIndex = 4; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'DK') {select.selectedIndex = 5; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'EE') {select.selectedIndex = 6; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'FI') {select.selectedIndex = 7; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'FR') {select.selectedIndex = 8; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'GR') {select.selectedIndex = 9; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'HU') {select.selectedIndex = 10; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'IE') {select.selectedIndex = 11; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'IT') {select.selectedIndex = 12; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'LV') {select.selectedIndex = 13; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'LT') {select.selectedIndex = 14; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'LU') {select.selectedIndex = 15; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'NL') {select.selectedIndex = 16; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'PT') {select.selectedIndex = 17; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'RO') {select.selectedIndex = 18; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'SK') {select.selectedIndex = 19; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'SI') {select.selectedIndex = 20; updateSelectedCountry()}
//   if (window.jwsdwSettings.countryCode === 'SE') {select.selectedIndex = 21; updateSelectedCountry()}
// }
